module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n      产品升级\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group-list domain-list"
  }, [_c('div', {
    staticClass: "form-group margin-bottom-20"
  }, [_c('div', {
    staticClass: "form-group-item code-input-box select-box flex",
    staticStyle: {
      "height": "2.7rem"
    }
  }, [_c('p', {
    staticClass: "left-desc text-gray"
  }, [_vm._v("当前配置")]), _vm._v(" "), _c('div', {
    staticClass: "flex1 fluid-layout-parent"
  }, [_c('span', {
    staticClass: "flex1per2"
  }, [_vm._v("网站空间( " + _vm._s(_vm.shengjiForm.websize) + " )")]), _vm._v(" "), _c('span', {
    staticClass: "flex1per2"
  }, [_vm._v("MySql( " + _vm._s(_vm.shengjiForm.mysql) + " )")]), _vm._v(" "), _c('span', {
    staticClass: "flex1per2"
  }, [_vm._v("MsSql( " + _vm._s(_vm.shengjiForm.mssql) + " )")]), _vm._v(" "), _c('span', {
    staticClass: "flex1per2"
  }, [_vm._v("子网站( " + _vm._s(_vm.shengjiForm.subweb) + "个 )")]), _vm._v(" "), _c('span', {
    staticClass: "flex1per2"
  }, [_vm._v("带宽( " + _vm._s(_vm.shengjiForm.daikuan) + " )")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-bottom-20"
  }, [_c('div', {
    staticClass: "form-group-item code-input-box select-box flex",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('p', {
    staticClass: "left-desc"
  }, [_vm._v("升级套餐名称")]), _vm._v(" "), _c('div', {
    staticClass: "right-select-box flex1 flex",
    attrs: {
      "id": "upgradeSpace"
    }
  }, _vm._l((_vm.shengjiForm.config), function(item, index) {
    return _c('span', {
      staticClass: "another-option flex1per2",
      class: {
        'selected': _vm.shengjiForm.type == item.value
      },
      on: {
        "click": function($event) {
          _vm.Choose(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group-item code-input-box select-box flex",
    staticStyle: {
      "height": "2.7rem"
    }
  }, [_c('p', {
    staticClass: "left-desc text-gray"
  }, [_vm._v("当前配置")]), _vm._v(" "), _c('div', {
    staticClass: "flex1 fluid-layout-parent"
  }, _vm._l((_vm.shengjiForm.pset), function(option) {
    return _c('span', {
      staticClass: "flex1per2"
    }, [_vm._v(_vm._s(option.replace(' ', '')))])
  }))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group-item"
  }, [_c('popup-picker', {
    attrs: {
      "title": "优惠券",
      "data": _vm.shengjiForm.yhq,
      "columns": 1
    },
    on: {
      "on-hide": _vm.levelPrice
    },
    model: {
      value: (_vm.shengjiForm.coupon),
      callback: function($$v) {
        _vm.$set(_vm.shengjiForm, "coupon", $$v)
      },
      expression: "shengjiForm.coupon"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group-item"
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "form-content"
  }, [_c('b', {
    staticClass: "text-stress",
    attrs: {
      "id": "upgradePrice"
    }
  }, [_vm._v(_vm._s(_vm.shengjiForm.price) + "元")])])])])]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": ".5rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.Level($event)
      }
    }
  }, [_vm._v("确认")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "alert-warn margin-bottom-20 domain-list"
  }, [_c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("云虚拟主机升级后，到期时间不变，升级的差价计算精确到天；")]), _vm._v(" "), _c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("升级/降级费用最低10元起，不足10元的按10元；")]), _vm._v(" "), _c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("升级价格计算公式：(升级配置价格[年] - 原始配置价格[年]) / 365 * 到期剩余天数；")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group-item"
  }, [_c('span', {
    staticClass: "form-label text-gray"
  }, [_c('span', {
    staticClass: "must-mark"
  }), _vm._v(" "), _c('span', [_vm._v("到期时间")])]), _vm._v(" "), _c('span', {
    staticClass: "form-content"
  }, [_c('span', {}, [_vm._v("2019-07-31 09:32:39")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "form-label text-gray"
  }, [_c('span', {
    staticClass: "must-mark"
  }), _vm._v(" "), _c('span', [_vm._v("费用")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43a50880","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/hostlevel.vue
// module id = 32F9
// module chunks = 1